export const ERF_TYPES = [
  {
    id: 1,
    code: "SL",
    name: "Sale",
    description: "Sale ERF Type",
    privileges: [
      { id: 1, name: "NOT APPLICABLE" },
      { id: 2, name: "SPECIAL CASE" },
      { id: 3, name: "DISCOUNT" },
      // { id: 4, name: "NO CARTAGE" },
      // { id: 5, name: "ZERO VALUE" },
      { id: 6, name: "GIFT" },
      // { id: 7, name: "DEMO" },
      // { id: 8, name: "CHEQUE & CASH" },
      // { id: 9, name: "PYMT. BY CHEQUE" },
      // { id: 10, name: "DISCOUNT+CARTAGE" },
      // { id: 11, name: "SPECIAL CASE+DISCOUNT" },
    ],
  },
  {
    id: 2,
    code: "RE",
    name: "Rent",
    description: "Rent ERF Type",
    privileges: [
      { id: 1, name: "NOT APPLICABLE" },
      { id: 2, name: "DISCOUNT" },
      { id: 3, name: "SPECIAL CASE" },
      // { id: 4, name: "NO SECURITY" },
      // { id: 5, name: "NO CARTAGE" },
      // { id: 6, name: "PYMT. IN CASH SECURITY" },
      // { id: 7, name: "PYMT. IN CHEQUE SECURITY" },
      // { id: 8, name: "DISCOUNT+SECURITY" },
      // { id: 9, name: "ZERO VALUE" },
      { id: 10, name: "GIFT" },
      // { id: 11, name: "DEMO" },
      // { id: 12, name: "CHEQUE & CASH" },
      // { id: 13, name: "PYMT. BY CHEQUE" },
      // { id: 14, name: "DISCOUNT+CARTAGE" },
      // { id: 15, name: "DISCOUNT+CARTAGE+SECURITY" },
      // { id: 16, name: "LESS SECURITY" },
      // { id: 17, name: "SPECIAL CASE+DISCOUNT" },
    ],
  },
  {
    id: 3,
    code: "SLRE",
    name: "Sale & Rent",
    description: "Property for Sale and Rent ERF Type",
    privileges: [
      { id: 1, name: "NOT APPLICABLE" },
      { id: 2, name: "DISCOUNT" },
      { id: 3, name: "SPECIAL CASE" },
      // { id: 4, name: "NO CARTAGE" },
      // { id: 5, name: "ZERO VALUE" },
      { id: 6, name: "GIFT" },
      // { id: 7, name: "DEMO" },
      // { id: 8, name: "CHEQUE & CASH" },
      // { id: 9, name: "NO SECURITY" },
      // { id: 10, name: "PYMT. IN CASH SECURITY" },
      // { id: 11, name: "PYMT. IN CHEQUE SECURITY" },
      // { id: 12, name: "DISCOUNT+SECURITY" },
      // { id: 13, name: "PYMT. BY CHEQUE" },
      // { id: 14, name: "DISCOUNT+CARTAGE" },
      // { id: 15, name: "DISCOUNT+CARTAGE+SECURITY" },
      // { id: 16, name: "LESS SECURITY" },
      // { id: 17, name: "SPECIAL CASE+DISCOUNT" },
    ],
  },
  {
    id: 4,
    code: "SV",
    name: "Service",
    description: "Service ERF Type",
    privileges: [
      { id: 1, name: "NOT APPLICABLE" },
      { id: 2, name: "SPECIAL CASE" },
      { id: 3, name: "DISCOUNT" },
      // { id: 4, name: "NO CARTAGE" },
      // { id: 5, name: "ZERO VALUE" },
      { id: 6, name: "GIFT" },
      // { id: 7, name: "DEMO" },
      // { id: 8, name: "CHEQUE & CASH" },
      // { id: 9, name: "PYMT. BY CHEQUE" },
      // { id: 10, name: "DISCOUNT+CARTAGE" },
      // { id: 11, name: "SPECIAL CASE+DISCOUNT" },
    ],
  },
  {
    id: 5,
    code: "NR",
    name: "Nursing Service",
    description: "Nursing Service ERF Type",
    privileges: [
      { id: 1, name: "NOT APPLICABLE" },
      { id: 2, name: "SPECIAL CASE" },
      { id: 3, name: "DISCOUNT" },
      // { id: 4, name: "NO CARTAGE" },
      // { id: 5, name: "ZERO VALUE" },
      { id: 6, name: "GIFT" },
      // { id: 7, name: "DEMO" },
      // { id: 8, name: "CHEQUE & CASH" },
      // { id: 9, name: "PYMT. BY CHEQUE" },
      // { id: 10, name: "DISCOUNT+CARTAGE" },
      // { id: 11, name: "SPECIAL CASE+DISCOUNT" },
    ],
  },
];

export const PRIVILEGE_SETTINGS = {
  "SPECIAL CASE": {
    allowSellBelowLRP: true,
    editAmount: true, // Allow editing Total
    editTax: true, // Allow editing Tax
    disableCartage: false,
    disableSecurityDetails: false,
    securityAmtModeOptions: null,
  },
   "NOT APPLICABLE": {
    allowSellBelowLRP: false,
    editAmount: false, // Allow editing Total
    editTax: false, // Allow editing Tax
    disableCartage: false,
    disableSecurityDetails: false,
    securityAmtModeOptions: null,
  },
  "DISCOUNT": {
    allowSellBelowLRP: false,
    editAmount: false, // Allow editing Total
    editTax: false, // Allow editing Tax
    disableCartage: false,
    disableSecurityDetails: false,
    securityAmtModeOptions: null,
  },
  "DISCOUNT+SECURITY": {
    allowSellBelowLRP: false,
    editAmount: false, // Allow editing Total
    editTax: false, // Allow editing Tax
    disableCartage: false,
    disableSecurityDetails: false,
    securityAmtModeOptions: null,
  },
  "NO CARTAGE": {
    disableCartage: true,
  },
  "DISCOUNT+CARTAGE": {
    disableCartage: true,
  },
  "DISCOUNT+CARTAGE+SECURITY": {
    disableCartage: true,
    disableSecurityDetails: true,
  },
  "NO SECURITY": {
    editAmount: false, // Allow editing Total
    editTax: false, // Allow editing Tax
    disableCartage: false,
    disableSecurityDetails: true,
  },
  "GIFT": {
    allowSellBelowLRP: true,
    editAmount: true, // Allow editing Total
    editTax: true, // Allow editing Tax
    disableCartage: false,
    disableSecurityDetails: false,
    securityAmtModeOptions: null,
  },
  "PYMT. IN CASH SECURITY": {
    securityAmtModeOptions: ["Cash"],
  },
  "PYMT. IN CHEQUE SECURITY": {
    securityAmtModeOptions: ["Cheque"],
  },
  "ZERO VALUE": {
    securityAmtModeOptions: [], // Empty options
  },
  "DEMO": {
    securityAmtModeOptions: [], // Empty options
  },
};

// Default settings for cases not explicitly listed
export const DEFAULT_PRIVILEGE_SETTINGS = {
  allowSellBelowLRP: false,
  editAmount: false,
  editTax: false,           
  disableCartage: false,
  disableSecurityDetails: false,
  securityAmtModeOptions: null,
};

export const PAYMENT_MODES = {
  NR: "NR",
  CASH: "Cash",
  CARD: "Card",
  CHEQUE: "Cheque",
  ONLINE: "Online",
  CARD_CASH: "Card&Cash",
  CHEQUE_CASH: "Cheque&Cash",
  DOLLAR: "Dollar",
  EURO: "Euro",
  PAYTM: "Paytm",
  UPI: "UPI",
  CARD_CHEQUE: "Card&Cheque",
};

export const PAYMENT_MODE_RULES = {
  [PAYMENT_MODES.NR]: { disableAll: true },
  [PAYMENT_MODES.CASH]: {
    disableCheque: true,
    disableCard: true,
    disableBank: true,
    disableReceipt: true,
  },
  [PAYMENT_MODES.CARD]: {
    disableCash: true,
    disableCheque: true,
    disableReceipt: true,
  },
  [PAYMENT_MODES.CHEQUE]: {
    disableCash: true,
    disableCard: true,
    disableReceipt: true,
  },
  [PAYMENT_MODES.ONLINE]: {
    disableCash: true,
    disableCard: true,
    disableCheque: true,
    disableReceipt: true,
  },
  [PAYMENT_MODES.CARD_CASH]: { disableCheque: true, disableReceipt: true },
  [PAYMENT_MODES.CHEQUE_CASH]: { disableCard: true, disableReceipt: true },
  [PAYMENT_MODES.CARD_CHEQUE]: { disableBank: true, disableReceipt: true },
  [PAYMENT_MODES.DOLLAR]: {
    disableCash: true,
    disableCheque: true,
    disableCard: true,
    disableReceipt: true,
  },
  [PAYMENT_MODES.EURO]: {
    disableCash: true,
    disableCheque: true,
    disableCard: true,
    disableReceipt: true,
  },
  [PAYMENT_MODES.PAYTM]: {
    disableCash: true,
    disableCheque: true,
    disableCard: true,
    disableReceipt: true,
  },
  [PAYMENT_MODES.UPI]: {
    disableCash: true,
    disableCheque: true,
    disableCard: true,
    disableReceipt: true,
  },
};
 